<ion-row class="forbruk-graphs-container-row">
  <ion-col sizeXl="6" size="12">
    <!-- FORBRUK -->
    <app-forbruk
      [availableYearsForbruk]="availableYearsForbruk"
      [selectedYearsForbrukMonth]="selectedYearsForbrukMonth"
      [hasFetchingError]="hasFetchingError"
      [valgtAarAnlegg]="valgtAarAnlegg"
      [minDate]="minDate"
      [valgtMaanedAnlegg]="valgtMaanedAnlegg"
      [valgtDagAnlegg]="valgtDagAnlegg"
      [selectedDateDay]="selectedDateDay"
      [valgtTimeAnlegg]="valgtTimeAnlegg"
      [selectedDateHour]="selectedDateHour"
      (selectedYearsForbrukMonthChange)="setSelectedYearsForbrukMonth($event)"
    ></app-forbruk>
  </ion-col>
  <ion-col sizeXl="6" size="12">
    <!-- KOSTNAD-->
    <app-kostnad
      [availableYearsForbruk]="availableYearsForbruk"
      [selectedDateMonth]="selectedDateMonth"
      [valgtAarAnlegg]="valgtAarAnlegg"
      [isBrowser]="isBrowser"
      [hasFetchingError]="hasFetchingError"
      [minDate]="minDate"
      [valgtMaanedAnlegg]="valgtMaanedAnlegg"
      [valgtDagAnlegg]="valgtDagAnlegg"
      [selectedDateDay]="selectedDateDay"
      [valgtTimeAnlegg]="valgtTimeAnlegg"
      [selectedDateHour]="selectedDateHour"
      [selectedDate]="selectedDateDay"
      [valgtAvtale]="valgtAvtale"
      [_foretakMap]="_foretakMap"
      (emitSelectedDateMonth)="setSelectedDateMonth($event)"
      [isStromstotteToggled]="isStromstotteToggled"
    ></app-kostnad>
  </ion-col>
</ion-row>
